import axios from 'axios';
import { logout } from '../../modules/user';
import { store } from '../../store';
import AuthService from '../../services/auth/authService';

export const authAspects = () => {
  if (!window.__RESTORE_fetchSet) {
    const { fetch: _fetch } = window;
    window.fetch = async (url, options) => {
      const token = AuthService.getAuthToken();

      if (url.includes(import.meta.env.VITE_API_SERVER)) {
        options.headers = {
          'Content-Type': 'application/json',
          Authorization: token,
        };
      }

      try {
        const response = await _fetch(url, options);
        let body = null;
        if (response.status !== 401) {
          body = await response.json();
          if (body.new_auth) {
            AuthService.storeTokens(body);
          }
        } else {
          store.dispatch(logout());
        }
        return { response, body };
      } catch (error) {
        if (error.response && error.response.status === 401) {
          store.dispatch(logout());
        }
        return error;
      }
    };

    axios.interceptors.request.use((config) => {
      const token = AuthService.getAuthToken();
      if ((config.url?.toString().includes(import.meta.env.VITE_API_SERVER) && config?.data?.Authorization) || token) {
        config.headers.Authorization = config?.data?.Authorization || token;
      }
      return config;
    });

    const handleResponse = async (response) => {
      const body = response.data;
      if (response.status === 401 && AuthService.getAuthToken()) {
        store.dispatch(logout());
      } else if (response.config.url.endsWith && response.config.url.endsWith('/logout')) {
        AuthService.clearAuth();
      } else if (body.new_auth) {
        AuthService.storeTokens(body);
      } else if (body.token) {
        AuthService.storeAuthState(body);
      }
      return response;
    };

    const handleError = async (error) => {
      // TODO: need special handle for /validate-reset-token end point to handle password reset error
      // const body = await error.json();
      if (error?.response?.status === 401 && AuthService.getAuthToken()) {
        //TODO: clear auth instead of running logout.
        store.dispatch(logout());
      }
      throw error;
    };

    axios.interceptors.response.use(handleResponse, handleError);

    window.__RESTORE_fetchSet = true;
  }
};
